import React from "react";
import { Redirect } from "react-router-dom";

// Active feature pages — keep this list TIGHT.
// Webpack parses the dependency graph of every import in dev mode, so adding a
// page here adds parse time on every reload. If you need an old template page
// back, copy it into src/pages/, then add it here.
//
// 2026-06: consolidated 13 feature pages into 7 nav hubs. The merged pages
// (Transactions, Paybis, Fees, Feedback, Form Submissions, Alerts,
// Notifications) were folded into hubs; Notifications is routed again since
// 2026-10-28 under "In the app". The rest are imported by the hub
// wrappers (Money, Voice, Operations) and old paths redirect into the hubs.
import Overview from "../pages/Overview";          // North Star (WEW) command center
import Money from "../pages/Money";                // Transactions · Paybis · Fees
import Growth from "../pages/Growth";              // App Metrics · Price Alerts
import Rewards from "../pages/Rewards";
import TokenListings from "../pages/TokenListings";
import Voice from "../pages/Voice";                // Feedback · Form Submissions
import Notifications from "../pages/Notifications"; // "In the app" › Notifications (push + Notifications screen)
import SystemHealth from "../pages/SystemHealth";   // Operations (health · errors)
import CoinGeckoUsage from "../pages/CoinGeckoUsage"; // CoinGecko API usage tracking
import UsersPage from "../pages/Users";

// Auth + RBAC
import Login from "../pages/Authentication/Login";
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import ResetPassword from "../pages/Authentication/ResetPassword";
import AcceptInvite from "../pages/Authentication/AcceptInvite";
import ChangePassword from "../pages/Authentication/ChangePassword";

const authProtectedRoutes = [
  { path: "/overview",      component: Overview,     requiredPermission: "dashboard.view" },
  // Hubs gate per-tab internally (any-of), so the route itself is ungated.
  { path: "/money",         component: Money },
  { path: "/growth",        component: Growth },
  { path: "/rewards",       component: Rewards,      requiredPermission: "rewards.view" },
  { path: "/voice",         component: Voice },
  { path: "/notifications", component: Notifications, requiredPermission: "notifications.view" },
  { path: "/token-listings", component: TokenListings, requiredPermission: "token_listings.view" },
  { path: "/system-health", component: SystemHealth },
  { path: "/coingecko-usage", component: CoinGeckoUsage, requiredPermission: "coingecko.view" },
  { path: "/users",         component: UsersPage,    requiredPermission: "users.view" },
  { path: "/change-password", component: ChangePassword },

  // ── Redirects from the pre-consolidation paths (keep bookmarks alive) ──
  // Money hub
  // eslint-disable-next-line react/display-name
  { path: "/transactions",        component: () => <Redirect to="/money" /> },
  // eslint-disable-next-line react/display-name
  { path: "/paybis-transactions", component: () => <Redirect to="/money" /> },
  // eslint-disable-next-line react/display-name
  { path: "/fees",                component: () => <Redirect to="/money" /> },
  // Growth
  // eslint-disable-next-line react/display-name
  { path: "/app-metrics",         component: () => <Redirect to="/growth" /> },
  // Voice hub
  // eslint-disable-next-line react/display-name
  { path: "/feedback",            component: () => <Redirect to="/voice" /> },
  // eslint-disable-next-line react/display-name
  { path: "/form-submissions",    component: () => <Redirect to="/voice" /> },
  // Growth hub
  // eslint-disable-next-line react/display-name
  { path: "/alerts",              component: () => <Redirect to="/growth" /> },
  // Old monitoring routes folded into System Health (2026-06-03/04).
  // eslint-disable-next-line react/display-name
  { path: "/api-status",          component: () => <Redirect to="/system-health" /> },
  // eslint-disable-next-line react/display-name
  { path: "/checks",              component: () => <Redirect to="/system-health" /> },
  // eslint-disable-next-line react/display-name
  { path: "/data-health",         component: () => <Redirect to="/system-health" /> },
  // eslint-disable-next-line react/display-name
  { path: "/app-errors",          component: () => <Redirect to="/system-health" /> },

  // Catch-all — must stay at the end.
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/overview" /> },
];

const publicRoutes = [
  { path: "/login",                  component: Login },
  { path: "/forgot-password",        component: ForgotPassword },
  { path: "/reset-password/:token",  component: ResetPassword },
  { path: "/accept-invite/:token",   component: AcceptInvite },
];

export { authProtectedRoutes, publicRoutes };
